import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ViewModeService } from '../../services/view-mode/view-mode.service';

@Component({
  selector: 'app-page-redirect',
  standalone: true,
  template: ''
})
export class PageRedirectComponent implements OnInit {

  constructor(private router: Router, private viewModeService: ViewModeService) {}

  ngOnInit() {
    const redirectTo = this.viewModeService.isSupplierView() ? 'pages/information-requests' : 'pages/home';
    this.router.navigate([redirectTo], { relativeTo: this.router.routerState.root });
  }
}